import styled from 'styled-components'
import { blue } from '../../styles/variables'

const List = styled.div`
  min-width: 300px;
`

const ListItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 10px 5px 10px 0;
  & > img {
    margin-right: 10px;
  }

  &.category {
    font-weight: bold;
    font-size: 18px;
    margin-top: 30px;
    margin-bottom: 10px;
    &:first-child {
      margin-top: 0;
    }
  }

  & > .icon {
    cursor: pointer;
    transition: all .1s ease-in-out;
    &:hover {
      transform: scale(1.1);
    }

    &.edit {
      margin-left: 10px;
      margin-right: 2px;
      color: #999;
      &:hover {
        color: black;
      }
    }
  }

  &.addIcon > img {
    margin-left: 26px;
  }

  &.addCategory {
    color: #444;
    cursor: pointer;
    margin-top: 20px;
    & > img {
      margin-left: 0;
    }
    &:hover {
      opacity: 0.7;
    }
  }

  &.subcategory {
    margin: 15px 0;
    cursor: pointer;
    &:hover {
      opacity: 0.7;
    }
  }

  &.error {
    color: red;
  }

  &.selected {
    color: ${blue};
    opacity: 1 !important;
  }

  &.subchildren {
    margin: 0 5px 10px 0;
  }

  &.subitem {
    margin-top: -10px;
    margin-left: 25px;
  }
`

const ItemInfo = styled.div`
  display: flex;
  flex-direction: column;
`
const ItemInfoTitle = styled.div`
  font-weight: bold;
`
const ItemInfoDescription = styled.div`
  font-size: 12px;
`

const AddSubchild = styled.div`
  display: flex;
  flex-direction: row;
  padding-left: 25px;
  margin-top: -15px;
  & > img {
    margin-right: 10px;
  }
  align-items: flex-end;
  & > .icon {
    cursor: pointer;
    transition: all .1s ease-in-out;
    &:hover {
      transform: scale(1.1);
    }

    &.edit {
      margin-left: 10px;
    }
  }
`

const Delete = styled.div`
  margin-left: 10px;
  cursor: pointer;
  color: #999;
  &:hover {
    transform: scale(1.1);
    color: red;
  }
`

export default {
  List,
  ListItem,
  ItemInfo,
  ItemInfoTitle,
  ItemInfoDescription,
  AddSubchild,
  Delete,
}
